import { render } from "./TypographyComponent.vue?vue&type=template&id=bdc549e4"
import script from "./TypographyComponent.vue?vue&type=script&lang=js"
export * from "./TypographyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__